/**
 * File navigation.js.
 */
(function () {

    const body = document.querySelector('body');
    document.querySelectorAll('.mobile-menu').forEach(function(menu) {
        menu.addEventListener("click", () => {
            body.classList.toggle("-mobile-menu");
        });
    });

    document.querySelectorAll('.nav-mobile a').forEach(function(a) {
        a.addEventListener('click', function () {
            body.classList.remove("-mobile-menu");
        });
    });

    window.addEventListener('scroll', () => {
        if (window.scrollY > 80) {
            body.classList.add("-sticky-nav");
        } else {
            body.classList.remove("-sticky-nav");
        }
    }, false);

}());
